import { getBearerToken } from "../../../api/postCall/bearerToken";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import { OrganizationType } from "../../../enums/organizationTypes";

export const updatePrimaryCareEntry = async (
  identifier: string,
  rowData: Record<string, string>,
): Promise<void> => {
  const response = await fetch(API_ENDPOINTS.UPDATE_PRIMARY_CARE_ENTRY, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${await getBearerToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      identifier,
      org_id: OrganizationType.ASTERA_PRIMARY_CARE,
      row_data: rowData,
    }),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to update entry");
  }
};
